import React, { Component } from 'react'
import { connect } from 'react-redux'

import BkFlowConfirmationDefault from './layouts/BkFlowConfirmationDefault'
import BkFlowConfirmationCondensed from './layouts/BkFlowConfirmationCondensed'
import modifyPreCheckIn from '../../actions/modifyPreCheckInActions'

import formatPrice from '../../utilities/currency/formatPrice'
import getCurrencySymbol from '../../utilities/currency/getCurrencySymbol'

import _ from 'lodash'
import yn from 'yn'
import triggerCustomGaEvent from "../../utilities/analytics/triggerCustomGaEvent";
import dayjs from "dayjs";

class BkFlowConfirmation extends Component {

	constructor(props) {
		super(props)
		this.state = {
			preCheckGroupExpanded: null,
			preCheckinModalVisible: false,
			socialMenuVisible: false,
			policiesModalVisible: false
		}

		this.openPreCheckInModal = this.openPreCheckInModal.bind(this)
		this.closePreCheckInModal = this.closePreCheckInModal.bind(this)
		window.scrollTo(0,0)
	}

	componentDidMount() {
		const urlData = this.props.urlData;
		const reservation = this.props.reservations[0];
		const room = this.props.reservations[0];
		const roomStays = room.roomStays[0];
		const { configData: { hotel: { options: { properties }} }} = this.props;

		const startDate = dayjs(urlData.startDate)
		const endDate = dayjs(urlData.endDate)

		const days = endDate.diff(startDate, 'days');

		triggerCustomGaEvent('verb_purchase', {
			arrival_date: urlData.startDate,
			departure_date: urlData.endDate,
			ecommerce: {
				currency: urlData.currency,
				value: reservation.resGlobalInfo.total.amountBeforeTax,
				tax: reservation.resGlobalInfo.total.taxes.amount,
				shipping: 0,
				transaction_id: reservation.id,
				coupon: urlData.promoCode,
				items: [{
					item_name: roomStays.roomTypes[0].roomDescription.name,
					item_id: roomStays.roomTypes[0].roomTypeCode,
					price: reservation.resGlobalInfo.total.amountBeforeTax / days,
					item_brand: properties.hotelCode,
					item_category: "Best Available Rate",
					item_variant: roomStays.roomTypes[0].viewExtensions.roomRates[0].ratePlanCode,
					quantity: days,
				}]
			}
		})
	}

	// preCheckin modal handlers
	openPreCheckInModal(e, tabKey) {
		e.preventDefault()
		this.setState({
			preCheckGroupExpanded: tabKey,
			preCheckinModalVisible: true
		})
	}

	closePreCheckInModal() {
		this.setState({ preCheckinModalVisible: false })
	}

	// preCheckin tab handlers
	handlePreCheckinPanel = panel => (event, expanded) => {
		this.setState({
			preCheckGroupExpanded: expanded ? panel : false,
		})
	}

	handleSocialMenuEvent = () => {
		this.setState({
			socialMenuVisible: !this.state.socialMenuVisible,
		})
	}

	handlePoliciesModalEvent = () => {
		this.setState({
			policiesModalVisible: !this.state.policiesModalVisible,
		})
	}

	render() {
		const {
			configData,
			dsp2TransactionData,
			urlData,
			preCheckTimeData,
			activeCurrencyData,
			reservations,
			reservationLoading,
			reservationError,
			modifyPreCheckin
		} = this.props

		const addTotals = (a, b) => a + b
		const confirmationData = reservations
		const hotelLabels = configData.hotel.labels[0]

		// localSession data for guests / pets
		let flowGuestData = null
		let activeHotelCode = null
		let activeHotelEmail = null
		let isTaxInclusiveProperty = false


		// Get hotel code from avail response
		if (!_.isEmpty(urlData) && urlData.hotelCode) {
			activeHotelCode = urlData.hotelCode
		}

		if (!_.isEmpty(configData)) {
			const configProperties = configData.hotel.options.properties

			// Match activeHotelCode to config properties array
			const matchedProperty = configProperties.find(function(property) {
				return property.hotelCode === String(activeHotelCode)
			})

			// Set email # by config or synxis fallback
			if ( !_.isEmpty(matchedProperty) && matchedProperty.reservationEmail ) {
				activeHotelEmail = matchedProperty.reservationEmail
			}

			if (
				!_.isEmpty(matchedProperty) &&
				matchedProperty.displayPricesTaxInclusive
			) {
				isTaxInclusiveProperty = matchedProperty.displayPricesTaxInclusive
			}
		}

		if (localStorage.flowGuestData) {
			flowGuestData = JSON.parse(localStorage.flowGuestData)
		}

		let renderItineraryId = _.get(reservations, '[0].id')
		let renderPropertyName = _.get(confirmationData, '[0].roomStays[0].basicPropertyInfo.hotelName')
		let renderArrival = _.get(confirmationData, '[0].roomStays[0].timeSpan.start')
		let renderDeparture = _.get(confirmationData, '[0].roomStays[0].timeSpan.end')
		let currencyCode = 'USD'
		let currencySymbol = getCurrencySymbol(currencyCode)
		let renderCurrencyCode = <span className="u-price-line__currency-code">{ currencyCode }</span>
		let renderPropertyLink = null
		let adultsData = []
		let childData = []
		let renderGuests = []
		let subTotalData = []
		let taxesFeesTotalData = []
		let taxTotalData = []
		let feeTotalData = []
		let totalData = []
		let enhancementsData = []
		let isPreCheckDisabled = true
		let reservationWarnings = _.get(confirmationData, '[0].warnings[0]', null)

		if (
			confirmationData &&
			confirmationData[0] &&
			confirmationData[0].roomStays &&
			confirmationData[0].roomStays[0]
		) {
			const confirmedRoomStays = confirmationData[0].roomStays[0]

			if (
				confirmedRoomStays.total &&
				confirmedRoomStays.total.currencyCode
			) {
				currencyCode = confirmedRoomStays.total.currencyCode
				currencySymbol = getCurrencySymbol(currencyCode)

				renderCurrencyCode = <span className="u-price-line__currency-code">{ currencyCode }</span>
			}
		}

		// Calculated exchange format for symbol and code
		if (
			yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
			activeCurrencyData &&
			activeCurrencyData.exchangeRate &&
			activeCurrencyData.currencyCode
		) {
			renderCurrencyCode = <span className="u-price-line__currency-code">{ activeCurrencyData.currencyCode }</span>

			if (activeCurrencyData.currencySymbol) {
				currencySymbol = activeCurrencyData.currencySymbol
			} else {
				currencySymbol = getCurrencySymbol(activeCurrencyData.currencyCode)
			}
		}

		// Get hotel code from avail response
		if (
			!_.isEmpty(urlData) &&
			urlData.hotelCode
		) {
			activeHotelCode = urlData.hotelCode
		}

		if (!_.isEmpty(configData)) {
			const configProperties = configData.hotel.options.properties

			// Match activeHotelCode to config properties array
			const matchedProperty = configProperties.find(function(property) {
				return property.hotelCode === String(activeHotelCode)
			})

			if ( !_.isEmpty(matchedProperty) && matchedProperty.marketingLink ) {
				renderPropertyLink = matchedProperty.marketingLink
			} else if (_.get(configData, 'core.options.links.brandMarketingLink')){
				renderPropertyLink = configData.core.options.links.brandMarketingLink
			}
		}

		// Set preCheckInData flag
		if (!_.isEmpty(preCheckTimeData)) {
			isPreCheckDisabled = false
		}

		// Construct and format guests totals
		if (flowGuestData) {
			for (let roomGroup in flowGuestData) {

				// get and set adults via localSession
				if (flowGuestData && flowGuestData[roomGroup].adults) {
					adultsData.push(Number(flowGuestData[roomGroup].adults))
				} else {
					adultsData.push(0)
				}

				// get and set children via localSession
				if (flowGuestData && flowGuestData[roomGroup].children) {
					childData.push(Number(flowGuestData[roomGroup].children))
				} else {
					childData.push(0)
				}
			}
		} else if (urlData) {
			// get and set adults via urlData
			if (urlData && urlData.adults) {
				adultsData.push(Number(urlData.adults))
			} else {
				adultsData.push(0)
			}

			// get and set children via urlData
			if (urlData && urlData.children) {
				adultsData.push(Number(urlData.children))
			} else {
				adultsData.push(0)
			}
		}

		let adultsTotal = 0
		let childTotal = 0

		if (!_.isEmpty(adultsData)) {
			adultsTotal = adultsData.reduce(addTotals, 0)
		}

		if (!_.isEmpty(childData)) {
			childTotal = childData.reduce(addTotals, 0)
		}

		if (adultsTotal === 1) {
			renderGuests.push(
				<span key={ hotelLabels.adult }>
					{ adultsTotal + ' ' + hotelLabels.adult }
				</span>
			)
		} else if (adultsTotal > 1) {
			renderGuests.push(
				<span key={ hotelLabels.adults }>
					{ adultsTotal + ' ' + hotelLabels.adults }
				</span>
			)
		}

		if (childTotal === 1) {
			renderGuests.push(
				<span key={ hotelLabels.child }>
					{', ' + childTotal + ' ' + hotelLabels.child }
				</span>
			)
		} else if (childTotal > 1) {
			renderGuests.push(
				<span key={ hotelLabels.children }>
					{', ' + childTotal + ' ' + hotelLabels.children }
				</span>
			)
		}

		// Construct enhancements total
		for (let confirmationGroup in confirmationData) {
			const currentConfirmationGroup = confirmationData[confirmationGroup]
			const enhancements = currentConfirmationGroup.services

			if (currentConfirmationGroup.roomStays) {
				if (_.get(currentConfirmationGroup.roomStays, '[0].total.amountBeforeTax')) {
					subTotalData.push(currentConfirmationGroup.roomStays[0].total.amountBeforeTax)
				}

				if (_.get(currentConfirmationGroup.roomStays, '[0].total.amountAfterTax')) {
					totalData.push(currentConfirmationGroup.roomStays[0].total.amountAfterTax)

					if (_.get(currentConfirmationGroup.roomStays, '[0].total.amountBeforeTax')) {
						const combinedTaxesFees = Number(currentConfirmationGroup.roomStays[0].total.amountAfterTax) - Number(currentConfirmationGroup.roomStays[0].total.amountBeforeTax)
						taxesFeesTotalData.push(Number(combinedTaxesFees.toFixed(2)))
					}
				}

				if (_.get(currentConfirmationGroup.roomStays, '[0].total.taxes.amount')) {
					taxTotalData.push(currentConfirmationGroup.roomStays[0].total.taxes.amount)
				}

				if (_.get(currentConfirmationGroup.roomStays, '[0].total.viewExtensions.fees.amount')) {
					feeTotalData.push(currentConfirmationGroup.roomStays[0].total.viewExtensions.fees.amount)
				}
			}

			// Gather enhancements pricing data
			if (
				!_.isEmpty(enhancements) &&
				enhancements !== ''
			) {
				for (let enhancement in enhancements) {
					const enhancementPrice = enhancements[enhancement].price[0].base.amountAfterTax

					if (enhancementPrice) {
						enhancementsData.push(enhancementPrice)
					} else {
						enhancementsData.push(0)
					}
				}
			}
		}

		let enhancementsTotal = enhancementsData.reduce(addTotals, 0)
		let renderEnhancementsTotal = formatPrice(enhancementsTotal)

		// Combine pricing data totals
		const renderSubTotal = subTotalData.reduce(addTotals, 0)
		const renderTaxesFeesTotal = taxesFeesTotalData.reduce(addTotals, 0)
		const renderTaxTotal = taxTotalData.reduce(addTotals, 0)
		const renderFeeTotal = feeTotalData.reduce(addTotals, 0)
		const renderTotal = totalData.reduce(addTotals, 0)

		let socialTwitterContent = null
		let socialEmailContent = null

		if (process.env.REACT_APP_COMPONENT_SOCIAL_TWITTER_CONTENT) {
			socialTwitterContent = process.env.REACT_APP_COMPONENT_SOCIAL_TWITTER_CONTENT
		}

		if (process.env.REACT_APP_COMPONENT_SOCIAL_EMAIL_CONTENT) {
			socialEmailContent = process.env.REACT_APP_COMPONENT_SOCIAL_EMAIL_CONTENT
		}

		return (
			process.env.REACT_APP_COMPONENT_CONFIRMATION_LAYOUT === 'condensed' ? (
				<BkFlowConfirmationCondensed
					configData={configData}
					dsp2TransactionData={dsp2TransactionData}
					hotelLabels={hotelLabels}
					isTaxInclusiveProperty={isTaxInclusiveProperty}
					reservations={reservations}
					policiesModalEvent={this.handlePoliciesModalEvent}
					policiesModalVisible={this.state.policiesModalVisible}
					reservationWarnings={reservationWarnings}
					socialMenuEvent={this.handleSocialMenuEvent}
					socialMenuVisible={this.state.socialMenuVisible}
				/>
			) : (
				<BkFlowConfirmationDefault
					activeCurrencyData={activeCurrencyData}
					activeHotelEmail={activeHotelEmail}
					closePreCheckInModal={this.closePreCheckInModal}
					currencySymbol={currencySymbol}
					handlePreCheckinPanel={this.handlePreCheckinPanel}
					hotelLabels={hotelLabels}
					isPreCheckDisabled={isPreCheckDisabled}
					modifyPreCheckin={modifyPreCheckin}
					preCheckGroupExpanded={this.state.preCheckGroupExpanded}
					preCheckinModalVisible={this.state.preCheckinModalVisible}
					renderArrival={renderArrival}
					renderCurrencyCode={renderCurrencyCode}
					renderDeparture={renderDeparture}
					renderEnhancementsTotal={renderEnhancementsTotal}
					renderFeeTotal={renderFeeTotal}
					renderGuests={renderGuests}
					renderItineraryId={renderItineraryId}
					renderPropertyLink={renderPropertyLink}
					renderPropertyName={renderPropertyName}
					renderSubTotal={renderSubTotal}
					renderTaxesFeesTotal={renderTaxesFeesTotal}
					renderTaxTotal={renderTaxTotal}
					renderTotal={renderTotal}
					reservationError={reservationError}
					reservationLoading={reservationLoading}
					reservations={reservations}
					reservationWarnings={reservationWarnings}
					socialEmailContent={socialEmailContent}
					socialTwitterContent={socialTwitterContent}
				/>
			)
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		dsp2TransactionData: state.dsp2TransactionData,
		urlData: state.availabilityData.urlData,
		activeEnhancementData: state.activeEnhancementData,
		activeStep: state.activeStepData.activeStep,
		activeCurrencyData: state.activeCurrencyData,
		reservations: state.reservationData.confirmation,
		reservationLoading: state.reservationData.loading,
		reservationError: state.reservationData.error,
		preCheckTimeData: state.preCheckTimeData,
	}
}

const mapDispatchToProps = dispatch => ({
	modifyPreCheckin() {
		return (
			dispatch(modifyPreCheckIn())
		)
	}
})
export default connect(mapStateToProps, mapDispatchToProps)(BkFlowConfirmation)


// WEBPACK FOOTER //
// ./src/components/confirmation/BkFlowConfirmation.js